<template>
  <div class="menu-inner">
    <!-- 主菜单 -->
    <div class="menu-main">
      <a :href="url" target="_blank" title="新开窗口" rel="opener">
        <div class="logo">
          <!-- 学校 -->
          <template v-if="roleId == '3'">
            <img
              v-if="$store.state.common.bureau.schoolShowType == '1'"
              src="/logoWhite.png"
            />
            <img
              v-if="$store.state.common.bureau.schoolShowType == '2'"
              :src="$store.state.common.bureau.schoolLogoUrl"
            />
          </template>
          <!-- 课程方 -->
          <template v-else-if="roleId == '4'">
            <img
              v-if="$store.state.common.bureau.institutionShowType == '1'"
              src="/logoWhite.png"
            />
            <img
              v-if="$store.state.common.bureau.institutionShowType == '2'"
              :src="$store.state.common.bureau.institutionLogoUrl"
            />
          </template>
          <!-- 教育局 -->
          <template v-else-if="roleId == '2'">
            <img
              v-if="$store.state.common.bureau.bureauShowType == '1'"
              src="/logoWhite.png"
            />
            <img
              v-if="$store.state.common.bureau.bureauShowType == '2'"
              :src="$store.state.common.bureau.bureauLogoUrl"
            />
          </template>
          <img v-else src="/logoWhite.png" />
        </div>
      </a>
      <ul class="menu-list">
        <li
          class="item"
          :class="{
            'item-active': firstId == item.id,
            'item-hover': hoverId == item.id,
          }"
          v-for="(item, index) in menuList"
          :key="index"
        >
          <span class="item-content" @click="selectItem(item)">
            <img
              v-if="menu_click.id != item.id"
              :src="'/icon/' + item.icon + '.png'"
            />
            <img v-else :src="'/icon/' + item.icon + 'Dark.png'" />
            <span class="item-name">{{ item.name }}</span>
          </span>
          <span v-if="firstId == item.id" class="item-content-children">
            <li
              v-for="(children, index1) in item.children"
              :key="index1"
              :class="{ 'second-menu-active': secondId == children.id }"
              @click="selectSecondItem(children)"
              class="item-name-children"
            >
            <div>
              <span v-if="children.name !== '老师考勤明细'">{{ children.name }}</span>
            </div>
            </li>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { setTimeout } from 'timers'
import permission from '../api/permission'
export default {
  name: 'sideMenu',
  data() {
    return {
      isShowSecond: false, //是否展示二级菜单
      menu_click: {}, //点击选择的item
      menu: {}, //展示的ID
      hoverId: '', //移动到第一级菜单的hover状态，注意，这里只能用遍历，不能使用css hover，因为二级菜单需要联动
      firstId: '', //一级菜单选择的ID
      secondId: '', //二级菜单选择的ID
      menuList: [], //菜单数据
      roleId: '',
      url: '',
    }
  },
  methods: {
    //根据ID找到父节点的ID
    getFatherItem(list, path) {
      let res
      function _getFatherId_fun(list, path, fatherItem) {
        for (let i in list) {
          if (list[i].children && list[i].children.length > 0) {
            _getFatherId_fun(list[i].children, path, list[i])
          }
          if (list[i].path == path) {
            //如果有上一级就返回上一级，没有就返回当前ID
            res = fatherItem ? fatherItem : path
          }
        }
      }
      _getFatherId_fun(list, path)
      return res
    },

    //根据path找到节点
    getItem(list, path) {
      let res
      function _getFatherId_fun(list, path, fatherItem) {
        for (let i in list) {
          if (list[i].children && list[i].children.length > 0) {
            _getFatherId_fun(list[i].children, path, list[i])
          }
          if (list[i].path == path) {
            //如果有上一级就返回上一级，没有就返回当前ID
            res = list[i]
          }
        }
      }
      _getFatherId_fun(list, path)
      return res
    },

    //鼠标移动到第一级菜单
    // hoverFirstItem(item){
    //   setTimeout(() => {
    //     this.hoverId = item.id;
    //     this.menu = item;
    //   }, 100);
    //
    // },
    // //鼠标离开第一级菜单
    // leaveFirstItem(){
    //   setTimeout(() => {
    //     if(!this.isShowSecond){
    //       this.menu = this.menu_click;
    //       this.hoverId = '';
    //     }
    //   }, 100);
    // },

    //鼠标移动到第二级菜单
    hoverSecondItem() {
      this.isShowSecond = true
    },
    //鼠标离开第二级菜单
    leaveSecondItem() {
      this.isShowSecond = false
      this.menu = this.menu_click
    },

    //选择一个item
    selectItem(item) {
      this.menu_click = item
      this.menu = item
      this.firstId = item.id
      this.secondId = ''

      //先判断下一级有没有元素，再选择当前元素的第一个
      if (item.children[0]) {
          this.selectSecondItem(item.children[0])
      }
    },

    //选择一个二级菜单
    selectSecondItem(item) {
      console.log(item, '子路由列表是什么')
      let fatherItem = this.getFatherItem(this.menuList, item.path)
      
      this.menu = fatherItem
      this.menu_click = fatherItem
      this.firstId = fatherItem.id
      if (item.permName == "老师考勤明细") {
        this.secondId = fatherItem.children[1].id
        this.$router.push({ name: fatherItem.children[1].path, params: { originType: 'click' } })
      } else {
        this.secondId = item.id
        //originType点击时设置的跳转来源类型 click
        this.$router.push({ name: item.path, params: { originType: 'click' } })
      }
    },

    //初始化
    init() {
      //获取当前路由
      let fatherItem = this.getFatherItem(this.menuList, this.$route.name)
      if (!fatherItem) return
      this.menu = fatherItem
      // console.log('this.menu', this.menu)
      this.menu_click = fatherItem
      this.firstId = fatherItem.id
      this.secondId = this.getItem(this.menuList, this.$route.name).id
    },

    //  装填角色的权限菜单
    listMyPerms(call) {
      //  装填角色的权限菜单
      let self = this
      // console.log('2window菜单-----', window.menuList)

      if (window.menuList && window.menuList.length > 0) {
        // console.log('1window菜单-----', window.menuList)
        // 考勤明细侧边栏高亮老师考勤
        window.menuList.forEach(item => {
          item.children.forEach(ele =>{
            if(ele.name == '老师考勤明细'){
              ele.id = ele.id.replace('-1', '-3')
              console.log(ele.id,'qqqqqqqqqqqqqqq')
            }
          })
        });
        this.$set(this, 'menuList', window.menuList)
        let res = { code: 0 }
        call(res)
      } else {
        permission
          .listMyPerms()
          .then((res) => {
            // console.log('window菜单-----', window.menuList)
            
            console.log('res.data',res.data)
            for (let j = 0, lens = res.data.length; j < lens; j++) {
              self.treeData(res.data[j], j + 1)
            }
            window.menuList = res.data
            this.$set(this, 'menuList', res.data)
            call(res)
          })
          .catch((error) => {
            call(error)
          })
      }
    },

    //  递归循环权限菜单 处理可显示渲染的菜单数据
    treeData(data, j) {
      data.id = j + ''
      data.name = data.permName
      data.icon = data.permCode
      if (data.children && data.children.length > 0) {
        for (let i = 0, lens = data.children.length; i < lens; i++)
          this.treeData(data.children[i], j + '-' + (i + 1))
      }
    },

    //  获取路由,检查路由的来源的类型 click为点击来源，不执行click的来源的，其他都执行
    fetchData(to, form) {
      if (to.params.type && to.params.type == 'click') {
      } else {
        this.init()
      }
    },
  },
  mounted() {
    this.url = window.location.href
    let self = this

    //  装填角色的权限菜单
    this.listMyPerms((res) => {
      self.init()
    })
    this.$store.dispatch('getUserInfo').then((res) => {
      this.roleId = res.accRole.id
    })
  },
  watch: {
    $route: 'fetchData',
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

$itemHeight: 40px;

.menu-inner {
  height: 100vh;
  font-size: 14px;
  background: rgb(0, 21, 41);
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.15);
  transition: all 0.2s ease-in-out;
  width: 100px;
}
.show-menu-second {
  width: 200px;
}

.menu-main {
  display: inline-block;
  width: 100px;
  height: 100vh;
  vertical-align: top;
  .logo {
    height: 64px;
    text-align: center;
    img {
      margin-top: 14px;
      width: 40px;
      height: auto;
    }
  }
  .item {
    width: 100%;
    min-height: $itemHeight;
    line-height: 40px;
    color: #cfcfcf;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    .item-content {
      width: 100%;
      min-height: $itemHeight;
      padding: 0px 6px 0px 16px;
      overflow: hidden;
      white-space: nowrap;
      img {
        width: 18px;
        height: auto;
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
      }
    }
    .item-content-children {
      width: 100%;
      height: 100%;
      color: #333333;
      background: #ffffff !important;
      .item-name-children {
        padding-left: 16px;
      }
      .second-menu-active {
        // background: $bg-color-active;
        color: $primary-color;
        font-weight: bold;
        border-right: 2px solid $primary-color;
      }
      .item-name-children:hover {
        color: $primary-color-dark;
      }
    }
  }
  .item-active {
    background: $bg-color-active !important;
    color: black !important;
    box-shadow: 1px 0 3px rgba(0, 21, 41, 0.1);
    position: relative;
  }
  .item-hover {
    background: rgba($color: #ffffff, $alpha: 0.4);
    color: #f0f0f0;
  }
  .item > i {
    font-size: 14px;
  }
  .item-name {
    display: inline-block;
    margin-left: 6px;
  }
}
</style>
